import gql from 'graphql-tag';

export const queryForCommercialContacts = gql`
  query queryForCommercialContacts(
    $limit: Int!
    $page: Int!
    $query: CommercialContactSortOrQuery
    $sort: CommercialContactSortOrQuery
  ) {
    queryForCommercialContacts(
      limit: $limit
      page: $page
      query: $query
      sort: $sort
    ) {
      items {
        id
        firstName
        lastName
        companyId
        jobRoleId
        deskPhone
        mobilePhone
        emailAddress
        ice
        createdAt
        createdBy
        updatedAt
        updater
        version
        Company {
          id
          name
        }
        JobRole {
          id
          name
        }
      }
      totalRecords
    }
  }
`;
